import React from "react";

const Washing_34 = React.forwardRef(
  ({ width = "33", height = "24", viewBox = "0 0 33 24", fill = "none", className }, ref) => {
    return (
      <svg
        ref={ref}
        {...{ width, height, viewBox, fill, className }}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.54386 2H30.1867V8.78634C29.7504 8.75618 29.1797 8.72138 28.4653 8.68666C26.5395 8.59307 23.5686 8.5 19.3682 8.5C11.0132 8.5 6.56153 9.46668 3.77718 13.4246C2.45424 15.3052 1.56513 17.6758 1.00983 19.5249C0.729353 20.4588 0.528261 21.2797 0.397001 21.8683C0.331303 22.1629 0.282919 22.4002 0.250695 22.5653C0.234579 22.6479 0.222493 22.7125 0.214293 22.7573L0.204887 22.8094L0.202334 22.8239L0.201196 22.8305L0 24H32.1867V0H6.54386V2ZM28.3682 10.6843C29.1487 10.7222 29.7505 10.7601 30.1867 10.7913V22H2.41843C2.53942 21.4828 2.70682 20.8277 2.92532 20.1001C3.45865 18.3242 4.27372 16.1948 5.41296 14.5754C7.55299 11.5333 10.9804 10.5 19.3682 10.5C23.5393 10.5 26.4776 10.5924 28.3682 10.6843ZM15 17C15 18.1046 14.1046 19 13 19C11.8954 19 11 18.1046 11 17C11 15.8954 11.8954 15 13 15C14.1046 15 15 15.8954 15 17ZM23 17C23 18.1046 22.1046 19 21 19C19.8954 19 19 18.1046 19 17C19 15.8954 19.8954 15 21 15C22.1046 15 23 15.8954 23 17Z"
          fill="black"
        />
      </svg>
    );
  },
);

export default Washing_34;
